import { Grid, Typography } from "@mui/material";
import styles from '../Information.module.scss';

const Human = () => {

    const serviceprograms = [
        {
            id: 1,
            Eventname: "Health Advisory Service",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 2,
            Eventname: "Helping Local Food Banks",
            image: "/images/shivatemple.svg"
        },
        {
            id: 3,
            Eventname: "Health Fair",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 4,
            Eventname: "Yoga class",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 4,
            Eventname: "Health Seminars",
            image: "/images/shivatemple.svg"
        },
        {
            id: 5,
            Eventname: "Thanksgiving Dinner (Livermore)",
            image: "/images/shivatemple.svg"
        },
        {
            id: 6,
            Eventname: "Grant-in-Aid",
            image: "/images/templeimagenew.svg"
        },
        {
            id: 6,
            Eventname: "Senior Group",
            image: "/images/shivatemple.svg"
        },
        {
            id: 7,
            Eventname: "Performing and donating ",
            image: "/images/templeimagenew.svg"
        }
    ]
    serviceprograms.sort((a, b) => a.Eventname.localeCompare(b.Eventname));
    return (
        <>
        <div className={styles.HumanLayout}>
            <div className={styles.cardContainer}>
                <Grid sx={{ padding: "24px" }}>
                    <Typography className={styles.content}>
                        <div>
                            1. The Human Services Committee is an integral part of HCCC and is chartered with the responsibility of serving the communities locally and globally on a need basis irrespective of religion, race, and cultural identity depending upon the available funds, on a priority and need basis.<br />
                        </div>
                        <div>
                            2. HCCC allocates limited amount of funds each year for supporting eligible organizations engaged strictly in Human Service functions. Recipient organizations will be required to disclose the affiliations with other organizations to enable HCCC to determine their eligibility to receive HCCC charity funds.<br />
                        </div>
                        <div>
                            3. Human Service projects are mainly aimed at basic human needs as food, shelter, medical and educational purposes. All of its funds will be spent in these areas only.<br />
                        </div>
                        <div>
                            4.Human Services Committee welcomes the association of individuals and groups who would like to identify, donate and execute projects for human cause within its spectrum of coverage<br />
                        </div>

                    </Typography>
                    <Grid>
                        <Grid sx={{ marginTop: "10px" }}>
                            <Typography className={styles.headercontent}>
                                Human Services Programs
                            </Typography>
                            <Grid>
                                <div style={{ width: "100%", marginLeft: "-10px" }}>
                                    {serviceprograms.map((offered, id) => (
                                        <div key={offered.id} style={{ display: "inline-block" }}>
                                            <div className={styles.container}>
                                                <Grid container alignItems="center" className={styles.grid}>
                                                    <div style={{ display: "inline-flex", alignItems: "center" }}>
                                                        <img src={offered.image} className={styles.images}/>
                                                        <div className={styles.offeredNameDiv}>
                                                            <Typography className={styles.offeredName} title={offered.Eventname}>{offered.Eventname}</Typography>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            </div>
        </>
    )
}
export default Human;